import React from "react";
import * as styles from "../newStyles.styles";

import styled, { css } from "react-emotion";

import { MenuToggler } from "components";

const headerSmallLogo = css`
  display: inline-block;
  margin-left: 4%;
  @media only screen and (min-width: 911px) {
    display: none;
  }
`;

const headerBigLogo = css`
  @media only screen and (max-width: 910px) {
    display: none;
  }
`;
const headerRow = css`
  margin-bottom: 0px;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 0px;
  background-color: white;
  @media only screen and (max-width: 910px) {
    margin-top: 10px;
    margin-bottom: 20px;
  }
`;

function Header({ history, hideMenu }) {
  const goToRoot = () =>
    history.push({
      pathname: "/",
    });

  return (
    <div>
      {/*Header Row*/}

      <div className={styles.row + " " + headerRow}>
        <img
          src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/logo_small.png"
          alt="header-logo"
          className={styles.headerLogoPic + " " + headerBigLogo}
          onClick={goToRoot}
        />

        <img
          className={styles.footerLogo + " " + headerSmallLogo}
          style={{ padding: "0px" }}
          src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Logo_footer.png"
          alt="footer-img"
        ></img>

        <div
          // className={styles.col + " " + styles.col3header}
          style={{
            textAlign: "right",
            marginRight: "4%",
            marginLeft: "0px",
            display: hideMenu ? "none" : "block",
          }}
        >
          <MenuToggler history={history}></MenuToggler>
        </div>
      </div>
    </div>
  );
}

export default Header;
